import React from "react";

const LipSyncIcon = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.5 12a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0zm1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM8 11a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2zm-8.818 2c-.619 0-1.093.561-.873 1.139a6.002 6.002 0 0011.216 0c.22-.578-.254-1.139-.873-1.139h-9.47z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default LipSyncIcon;
